// import { mapBgoRoma, mapSalionze } from "../../data/mapLinks";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import CorsiCard from "./CorsiCard";
import scherma from "../../assets/foto/scherma-1.jpg";

function Corsi() {
  const { t } = useTranslation();

  return (
    <section id="corsi" className="base-section">
      <div className="order-2 md:order-1">
        <img className="base-image" src={scherma} alt="scherma" />
      </div>
      <div className="base-text-container order-1 md:order-2">
        <h2 className="base-title">{t("corsi.title")}</h2>
        <p className="base-paragraph">{t("corsi.texts.ourMethod")}</p>
        <Link to="/corsi" className="base-link">
          {t("common.more")}
          <i className="fas fa-angle-right ml-1 text-xl text-current"></i>
        </Link>
      </div>
      {/* <div className="order-3 md:order-3 mt-8 md:mt-0 ">
                <CorsiCard 
                    city="Verona"
                    days={t("corsi.detail.verona.days")}
                    place={t("corsi.detail.verona.place")}
                    mapLink={mapBgoRoma}
                />
            </div>
            <div className="order-4 md:order-4">
                <CorsiCard 
                    city="Salionze"
                    days={t("corsi.detail.salionze.days")}
                    place={t("corsi.detail.salionze.place")}
                    mapLink={mapSalionze}
                />
            </div> */}
    </section>
  );
}

export default Corsi;
